import React from 'react';

import LocationOnIcon from '@mui/icons-material/LocationOn';
import {Box, Typography, Divider} from '@mui/material';
import {Suggestions} from 'use-places-autocomplete';

import {Loading} from 'components/loader/Loading';

interface IAddressSearchListView {
  suggestions: Suggestions;
  onSelect: (placeId: string, description: string) => void;
}
export const AddressSearchListView = ({suggestions, onSelect}: IAddressSearchListView) => {
  const _onClick = (placeId: string, description: string) => {
    onSelect(placeId, description);
  };

  if (suggestions.loading) {
    return <Loading />;
  }

  return (
    <Box sx={styles.container}>
      {suggestions.data.map((item) => (
        <Box
          key={item.place_id}
          sx={{cursor: 'pointer'}}
          onClick={() => _onClick(item.place_id, item.structured_formatting.main_text)}
        >
          <Box sx={styles.wrapper}>
            <LocationOnIcon sx={styles.icon} />
            <Box>
              <Typography sx={styles.title}>{item.structured_formatting.main_text}</Typography>
              <Typography sx={styles.address}>{item.structured_formatting.secondary_text}</Typography>
            </Box>
          </Box>
          <Divider sx={styles.divider} />
        </Box>
      ))}

      <Typography sx={styles.footer}>End of the list</Typography>
    </Box>
  );
};

const styles = {
  container: {
    margin: '0 auto',
    backgroundColor: '#fff',
    borderRadius: '8px'
  },
  wrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: '16px'
  },
  icon: {
    color: '#b0b0b0',
    fontSize: '32px',
    marginRight: '16px'
  },
  title: {
    fontWeight: 'bold',
    fontSize: '16px',
    color: '#000'
  },
  address: {
    fontSize: '14px',
    color: '#606060'
  },
  divider: {
    margin: '0 16px'
  },
  footer: {
    textAlign: 'center',
    padding: '16px',
    color: '#909090',
    fontSize: '14px'
  }
};
